import axios from '../../utils/AxiosUtils';

export const registerAppDevice = (brandId, token, uuid, platform) => {
    return (_, getState) => {
        const url = `/app/device-info?brandId=${brandId}`;

        let data = {
            'deviceId': uuid,
            'deviceToken': token,
            'devicePlatform': platform === 'Android' ? 'ANDROID' : 'IOS'
        };

        axios(getState).post(url, data)
            .then((response) => {
                console.log('[Push] device-info saved', {
                    brandId,
                    deviceId: uuid,
                    platform,
                    status: response && response.status
                });
            })
            .catch((error) => {
                const response = error && error.response;
                console.error('[Push] device-info failed', {
                    brandId,
                    deviceId: uuid,
                    platform,
                    message: error && error.message,
                    status: response && response.status,
                    body: response && response.data
                });
            });
    }
};